import React, {Component} from 'react'

export default class Text extends Component {

    constructor() {
        super()
        this.state = {
            label: '',
            error: ''
        }
    }

    onFocus() {
        this.setState({label: 'active'})
    }

    onBlur(e) {
        if (e.target.value) {
            this.props.setField(this.props.params.name, e.target.value, '')
        }
        if (!e.target.value) {
            this.state.label = 'inactive'
            if (this.props.state.fields[this.props.params.name].role.required) {
                this.props.setField(this.props.params.name, e.target.value, 'Kötelező megadni')
            }
        }

    }

    onChange(e) {
        if (e.target.value.indexOf('<') < 0 && e.target.value.indexOf('>') < 0) {
            this.setState({error: ''})
            this.props.setField(this.props.params.name, e.target.value)
        }
    }

    render() {
        if (this.props.state.fields[this.props.params.name].error) {
            this.state.error = <span className="error"><i className="fa fa-warning"></i> {this.props.state.fields[this.props.params.name].error}</span>
        } else {
            this.state.error = <span className="error"></span>
        }
        if (this.props.state.fields[this.props.params.name].value) {
            this.state.label = 'active'
        }
        let hasError = typeof this.state.error.props.children !== 'undefined' ? 'has-error' : ''
        return (
            <div className={'field field-text ' + this.props.params.id + ' ' + hasError} style={this.props.params.style}>
                <div>
                    <label htmlFor={this.props.params.id} className={this.props.params.classLabel}>
                        {this.props.params.label}
                    </label>
                    <input
                        type="password"
                        spellCheck="false"
                        autoComplete="off"
                        id={this.props.params.id}
                        className={this.props.params.classInput}
                        name={this.props.params.name}
                        onFocus={this.onFocus.bind(this)}
                        onBlur={this.onBlur.bind(this)}
                        onChange={this.onChange.bind(this)}
                        value={this.props.state.fields[this.props.params.name].value}
                        disabled={this.props.params.disabled}
                    />
                    <p className='help-block help-block-error'>{this.state.error}</p>
                </div>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/common/Field/Password.js